import React from 'react';
import {
  BrowserRouter,
  HashRouter,
  Routes,
  Route,
} from 'react-router-dom';
import { Helmet } from 'react-helmet';

import Header from './Header';
import KeywordSearch from './KeywordSearch';
import AdvancedSearch from './AdvancedSearch';
import FreeformSearch from './FreeformSearch.js';
import Browse from './Browse';
import SearchResults from './SearchResults';
import ViewDocument from './ViewDocument';
import About from './About';
import Support from './Support';
import Participants from './Participants';
import Affiliation from './Affiliation';
import Partners from './Partners';
import Biography from './Biography';
import Archive from './Archive';
import Bibliography from './Bibliography';
import SecondarySearch from './SecondarySearch.js';
import Translations from './Translations';
import LibraryOfCongress from './LibraryOfCongress';
import ScholarlyEdition from './ScholarlyEdition';
import Abstracts from './Abstracts';
import ClassroomEditions from './ClassroomEditions';
import UVACollection from './UVACollection';
import UVABibliography from './UVABibliography';
import UVAManuscripts from './UVAManuscripts.js';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import './App.css';
import Home from './Home';
import './css/tei.css';

import { SearchProvider, useSearchContext } from './SearchContext';

function RouterWrapper() {
  const { USE_HASH_ROUTER } = useSearchContext();
  const Router = USE_HASH_ROUTER ? HashRouter : BrowserRouter;

  // Set aside because I don't think we need the basename -ML
  //<Router {...(!USE_HASH_ROUTER ? { basename: '/brockdenbrown' } : {})}>
  return (
    <Router>
      <div className="App">
        <Helmet>
          <title>The Charles Brockden Brown Electronic Archive and Scholarly Edition</title>
          <meta charSet="utf-8" />
        </Helmet>
        <Header />
        <main className="main-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/search" element={<KeywordSearch />} />
            <Route path="/advanced-search" element={<AdvancedSearch />} />
            <Route path="/freeform-search" element={<FreeformSearch />} />
            <Route path="/browse" element={<Browse />} />
            <Route path="/searchresults" element={<SearchResults />} />
            <Route path="/view-document/:accessionNumber" element={<ViewDocument />} />
            <Route path="/about" element={<About />} />
            <Route path="/support" element={<Support />} />
            <Route path="/participants" element={<Participants />} />
            <Route path="/affiliation" element={<Affiliation />} />
            <Route path="/partners" element={<Partners />} />
            <Route path="/biography" element={<Biography />} />
            <Route path="/archive" element={<Archive />} />
            <Route path="/bibliography" element={<Bibliography />} />
            <Route path="/secondarysearch" element={<SecondarySearch />} />
            <Route path="/translations" element={<Translations />} />
            <Route path="/loc" element={<LibraryOfCongress />} />
            <Route path="/volumes" element={<ScholarlyEdition />} />
            <Route path="/summaries" element={<Abstracts />} />
            <Route path="/editions" element={<ClassroomEditions />} />
            <Route path="/uva-collection" element={<UVACollection />} />
            <Route path="/uva-bibliography" element={<UVABibliography />} />
            <Route path="/uva-manuscripts" element={<UVAManuscripts />} />
          </Routes>
        </main>
      </div>
    </Router>
  );
}

function App() {
  return (
    <SearchProvider>
      <RouterWrapper />
    </SearchProvider>
  );
}

export default App;
